import React from "react";
import { GridRow, GridColumn, LabeledText } from "sprint-common-web";

import { EmbeddedSubtitle } from "../../../../common/api/master-api/file-records/details/GetFileRecordDetailsResponse";
import { EmbeddedSubtitleType } from "../../../../common/types/EmbeddedSubtitleType";
import { getLanguageDisplayName } from "../../../../common/types/Language";
import { ensureVideoFileRecordDetails, FileRecordDetails } from "../FileRecordDetails";

interface VideoFileRecordSoundtrackLanguagesViewProps {
    fileRecordDetails: FileRecordDetails;
    height: number;
}

export const VideoFileRecordSoundtrackLanguagesView = ({
    fileRecordDetails,
    height
}: VideoFileRecordSoundtrackLanguagesViewProps): JSX.Element => {
    ensureVideoFileRecordDetails(fileRecordDetails);

    return (
        <GridRow style={{ height }}>
            <GridColumn sm={12}>
                <LabeledText
                    textStyle={{ textWrap: "wrap" }}
                    label="Soundtracks"
                    value={fileRecordDetails.soundtracks?.map((s) => getLanguageDisplayName(s)).join(", ")}
                    testId="file-record-soundtracks-field"
                />
            </GridColumn>
        </GridRow>
    );
};

interface VideoFileRecordSubtitlesLanguagesViewProps {
    fileRecordDetails: FileRecordDetails;
    height: number;
}

export const VideoFileRecordSubtitlesLanguagesView = ({
    fileRecordDetails,
    height
}: VideoFileRecordSubtitlesLanguagesViewProps): JSX.Element => {
    ensureVideoFileRecordDetails(fileRecordDetails);

    return (
        <GridRow style={{ height }}>
            <GridColumn sm={12}>
                <LabeledText
                    label="Subtitle"
                    value={getSubtitleName(fileRecordDetails.subtitle)}
                    testId="file-record-subtitle-field"
                />
            </GridColumn>
        </GridRow>
    );
};

const getSubtitleName = (subtitle?: EmbeddedSubtitle) => {
    if (!subtitle) return undefined;

    if (subtitle.type === EmbeddedSubtitleType.CleanVideo) {
        return "No Subs";
    }

    return getLanguageDisplayName(subtitle.language);
};
